export default "__VITE_ASSET__CgWuXBoz__"